export default () => ({
  blobs: [],
  loading: false,
  data: null,
  wrapTextNodes: false,
  currentDefinition: null,
  currentDefinitionPosition: null,
  currentBlobPath: null,
});
